import { useEffect, useRef, useState } from "react";

import { ReactComponent as ThreeDots } from "../../app/assets/icons/three-dots-action-icon.svg";

interface ActionIconSubItem {
  actionItemName: string;
  onClick?: (id: string) => void;
}
interface ThreeDotActionItemProps {
  actionIconSubItemsList: Array<ActionIconSubItem>;
  id: string;
  callRouteFlowDataObj?: {
    callRouteFlowData: object | null;
    isSingleCallRouteDataLoading: boolean;
  };
  actionItemsMenuPositionStyles?: Record<string, string>;
}

const ThreeDotActionItem = ({
  id,
  actionIconSubItemsList,
  actionItemsMenuPositionStyles,
}: ThreeDotActionItemProps) => {
  const [showActionMenuSubItem, setActionMenuSubItem] = useState(false);

  const iconContainerRef = useRef<SVGSVGElement>(null);

  const actionMenuIconClickHandler = () => {
    setActionMenuSubItem((prev) => !prev);
  };

  const handleActionItemClick = (item: ActionIconSubItem) => item.onClick?.(id);

  const outsideClickHandler = (event: MouseEvent) => {
    if (
      iconContainerRef.current &&
      !iconContainerRef.current.contains(event.target as Node)
    ) {
      setActionMenuSubItem(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", outsideClickHandler);

    return () => {
      document.removeEventListener("click", outsideClickHandler);
    };
  }, []);

  return (
    <>
      <ThreeDots
        className="cursor-pointer"
        ref={iconContainerRef}
        onClick={actionMenuIconClickHandler}
      />

      {showActionMenuSubItem && (
        <div
          className="z-2 action-menu-item text-center position-absolute"
          style={
            actionItemsMenuPositionStyles ? actionItemsMenuPositionStyles : {}
          }
        >
          {actionIconSubItemsList.map((item) => (
            <p className="m-0" onClick={() => handleActionItemClick(item)}>
              <span className="text-danger fs-12 fw-500">
                {item.actionItemName}
              </span>
            </p>
          ))}
        </div>
      )}
    </>
  );
};

export default ThreeDotActionItem;
